{
  "activities": {
    "accessoryProvider": "Proveedor de accesorios",
    "accessoryRawMaterialProvider": "Proveedor de materia prima",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Granja",
        "materialProduction": "Materia prima",
        "preProcessor": "Preprocesador"
      },
      "fabric": {
        "appret": "Acabado",
        "coating": "Recubrimiento",
        "dyeing": "Tintura/Impresión",
        "lamination": "Laminación",
        "materialProduction": "Materia prima",
        "spinning": "Hilado",
        "weavingKnitting": "Tejido/Punto"
      },
      "leather": {
        "appret": "Acabado",
        "dyeing": "Tintura",
        "farm": "Granja",
        "materialProduction": "Matadero",
        "tanning": "Curtido"
      },
      "manufacturing": "Fabricante",
      "yarn": {
        "dyeing": "Tintura",
        "materialProduction": "Materia prima",
        "spinning": "Hilado"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entidadCertificada",
    "footwear": {
      "assembling": "Ensamblaje",
      "finishing": "Acabado",
      "stitching": "Costura"
    },
    "paper": {
      "assembling": "Montaje",
      "bleaching": "Blanqueo",
      "chemicalTreatment": "Tratamiento químico",
      "laminating": "Laminado",
      "manufacturing": "Fabricación",
      "pressing": "Prensado",
      "printing": "Impresión",
      "resineRemoving": "Eliminación de resina",
      "whiteWashing": "Lavado en blanco"
    },
    "product": {
      "productWashing": "Product washing",
      "washing": "Washing"
    },
    "wood": {
      "assembling": "Montaje",
      "brushing": "Cepillado",
      "calibrationAndCollage": "Calibrado y collage",
      "harvesting": "Cosecha",
      "manufacturing": "Fabricación",
      "materialDrying": "Secado",
      "materialPeeking": "Clasificación",
      "materialPeeling": "Pelado",
      "materialSawing": "Aserrado",
      "sanding": "Lijado"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Seleccionar solo vacíos"
    },
    "applyButton": "Aplicar {{type}} a {{ itemCount }} elementos",
    "batchUpdateSuccess": "Actualización exitosa",
    "batchUpdateSuccessMessage_one": "1 solicitud de información ha sido actualizada",
    "batchUpdateSuccessMessage_many": "{{count}} solicitudes de información han sido actualizadas",
    "batchUpdateSuccessMessage_other": "{{count}} solicitudes de información han sido actualizadas",
    "info": "Hay <b>{{count}}</b> otros elementos con la actividad <b><activity/><b>",
    "labels": {
      "certificate": "Certificado",
      "clientName": "Nombre del cliente",
      "componentName": "nombre del componente",
      "componentReference": "Referencia del componente",
      "contact": "Contacto",
      "documentProof": "Documento de prueba",
      "informationRequestItemReference": "Referencia de la solicitud",
      "informationRequestItemReferenceHint": "Esto se refiere a la referencia del elemento al que está asociada la solicitud de información (por ejemplo, la referencia del producto, material o componente)",
      "materialName": "nombre del material",
      "materialProportion": "Proporción del material",
      "materialReference": "Referencia del material",
      "productCollection": "Colección de productos",
      "productColor": "Color del producto",
      "productId": "ID del producto",
      "productionSite": "Sitio de producción",
      "productName": "Nombre del producto",
      "productReference": "Referencia del producto",
      "purchaseOrder": "Orden de compra",
      "purchaseOrderRef": "Referencia de pedido",
      "reference": "Referencia"
    },
    "noDocument": "No hay documento",
    "searchProduct": "Buscar producto",
    "title": "¿Aplicar esta acción a varios elementos?"
  },
  "batchPopover": {
    "button": "Actualización masiva...",
    "certificateText": "¿Aplicar este certificado a varias solicitudes?",
    "text": "¿Aplicar esto {{key}} a varios <b><activity /></b>?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Certificado",
      "products": "Productos",
      "type": "type"
    },
    "success_one": "{{count}} solicitud de certificado actualizada con éxito",
    "success_many": "{{count}} solicitudes de certificado actualizadas con éxito",
    "success_other": "{{count}} solicitudes de certificado actualizadas con éxito"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Aceptado",
    "OPENED": "Abierto",
    "REJECTED": "Rechazado",
    "SUBMITTED": "En espera"
  },
  "certificates": {
    "actions": {
      "delete": "Eliminar",
      "submit": "Enviar",
      "transfer": "transferir"
    },
    "activityName": "Paso de trazabilidad:",
    "labels": {
      "maxIssueDate": "Fecha de creación máxima",
      "purchaseOrder": "Orden de compra o número de factura asociado"
    },
    "modal": {
      "areyousure": "¿Estás seguro de que quieres eliminar este certificado (esta acción es irreversible)?",
      "no": "No",
      "yes": "Sí, Eliminar"
    },
    "noRequests": {
      "closed": "No hay solicitudes completadas de certificados",
      "open": "No hay solicitudes pendientes de certificados"
    },
    "productionSite": "Sitio de producción",
    "productionSitePending": "Información del sitio de producción pendiente",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Ocultar productos",
        "seeMore": "Mostrar productos"
      },
      "productReferences": "Referencias de productos"
    },
    "reference": "Referencia: {{reference}}",
    "select": {
      "placeholder": "Selecciona un documento de tus cargas."
    },
    "upload": {
      "title": "Cargar certificado"
    }
  },
  "contactModal": {
    "labels": {
      "companyCity": "companyCity",
      "companyCityPlaceholder": "París",
      "companyCityTooltip": "Ciudad de la empresa",
      "companyCountry": "País",
      "companyCountryTooltip": "País de la empresa",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "Nombre de la empresa",
      "companyNamePlaceholder": "Nombre de la empresa",
      "companyNameTooltip": "Nombre público de la empresa",
      "companyPostalCode": "Código postal de la empresa",
      "companyPostalCodePlaceholder": "75001",
      "companyPostalCodeTooltip": "Código postal de la empresa",
      "companyRegistrationId": "ID de registro de la empresa",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "Número de IVA, CIN, GSTIN, USC, etc.",
      "companyRelationshipType": {
        "AGENT": "Agente",
        "BRAND": "Marca",
        "MANUFACTURER": "Fabricante",
        "OTHER": "Otro",
        "RAW_MATERIAL_SUPPLIER": "Proveedor de materia prima",
        "SUPPLIER": "Proveedor",
        "TRADER": "Comercializador"
      },
      "companyRelationshipTypeName": "Tipo",
      "companyRelationshipTypeTooltip": "Naturaleza de la empresa comercial utilizada para identificar su rol en la cadena de aprovisionamiento.",
      "companyStreet": "Calle",
      "companyStreetPlaceholder": "1 av. de Rivoli",
      "companyStreetTooltip": "Calle de la empresa",
      "companySupplierCode": "Código de proveedor",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Identificación corta del socio comercial utilizada en el interior.",
      "contactInformation": "contactInformation",
      "coordinates": "coordinates",
      "coordinatesPlaceholder": "coordinatesPlaceholder",
      "email": "Correo electrónico",
      "emailPlaceholder": "johndoe@gmail.com",
      "emailTooltip": "Dirección de correo electrónico para contactar con la empresa comercial",
      "name": "Nombre",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Identificación habitual del socio comercial, utilizada para intercambios por correo electrónico.",
      "preferredLanguage": "Idioma preferido",
      "tags": "Etiquetas",
      "tagsPlaceholder": "Agregar etiquetas...",
      "tagsTooltip": "Clasificación interna, calificación o cualquier otra información contextual."
    },
    "messages": {
      "create": {
        "error": "error",
        "success": "success"
      },
      "update": {
        "success": "success"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "Agregar un nuevo contacto",
      "contact": "Contacto",
      "you": "tú"
    },
    "placeholders": {
      "contact": "Buscar un contacto"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Actividad",
        "tooltip": "Última conexión registrada del socio."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} día",
        "averageResponseTimeValue_many": "averageResponseTimeValue",
        "averageResponseTimeValue_other": "{{nbDays}} días",
        "name": "Tiempo de respuesta promedio",
        "tooltip": "Tiempo promedio tomado para responder a las solicitudes de información."
      },
      "certificateRequests": {
        "name": "Solicitudes de certificados"
      },
      "code": {
        "name": "Código",
        "tooltip": "Código de identificación interno corto para el socio comercial."
      },
      "company": {
        "name": "Empresa",
        "tooltip": "Nombre público oficial de la empresa socia comercial."
      },
      "contactEmail": {
        "name": "Contacto (correo)",
        "tooltip": "Correo electrónico del contacto principal dentro de la empresa socia."
      },
      "contactName": {
        "name": "Contacto (nombre)",
        "tooltip": "Nombre del contacto principal dentro de la empresa socia."
      },
      "location": {
        "name": "Ubicación",
        "tooltip": "País de la empresa socia comercial"
      },
      "productionSiteRequests": {
        "name": "Solicitudes de sitios de producción",
        "received": "recibidas"
      },
      "productionSites": {
        "name": "Sitios de producción",
        "tooltip": "Recuento de sitios declarados por el socio comercial y recuento de países distintos."
      },
      "productRequests": {
        "name": "Solicitudes de productos"
      },
      "reminder": {
        "name": "Recordatorio",
        "tooltip": "Último recordatorio enviado al socio."
      },
      "requests": {
        "name": "Solicitudes",
        "tooltip": "Solicitudes respondidas por el socio."
      },
      "status": {
        "name": "Estado",
        "tooltip": "Identifica los socios comerciales actualmente activos y disponibles para el comercio."
      },
      "tags": {
        "name": "Etiquetas",
        "tooltip": "Clasificación interna, calificación o cualquier otra información contextual."
      },
      "type": {
        "name": "Tipo",
        "tooltip": "Naturaleza de la empresa socia utilizada para identificar su papel dentro de la cadena de suministro."
      }
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    }
  },
  "customFields": {
    "attachment": "Adjunto",
    "updateCustomField": {
      "customField": {
        "message": "El valor del campo personalizado ha sido actualizado y enviado al cliente",
        "title": "Valor del campo personalizado actualizado"
      },
      "customFieldProof": {
        "message": "El certificado del campo personalizado ha sido subido",
        "title": "Certificado del campo personalizado subido"
      }
    },
    "uploadCustomFieldProofTooltip": "Solicitar un certificado digital para soportar la información proporcionada"
  },
  "deselectAll": "Deseleccionar todo",
  "errors": {
    "axiosMessage": "Se produjo el siguiente error: {{message}} \n\n por favor intente de nuevo o contacte a support@traceforgood.com si el error persiste",
    "reinforcedTraceability": "No puedes asignar tu mismo a esta solicitud, por favor transfiere a la persona relevante",
    "title": "Ocurrió un error"
  },
  "filters": {
    "client": "Cliente",
    "search": "Buscar",
    "status": {
      "canceled": "Cancelado",
      "closed": "Cerrado",
      "opened": "Abierto",
      "placeholder": "Estado"
    },
    "title": "Filtros",
    "type": "Tipo"
  },
  "item": {
    "brand": "Marca",
    "client": "Cliente",
    "collection": "Colección",
    "color": "Color",
    "component": "Componente",
    "date": "Fecha del bono de compra",
    "marketLaunchDate": "Fecha de lanzamiento al mercado",
    "material_one": "Material",
    "material_other": "Materiales",
    "name": "Nombre",
    "product": "Producto",
    "purchaseOrderRef": "Orden de compra",
    "reference": "Referencia",
    "type": "Tipo"
  },
  "itemType": {
    "component": "Componente",
    "material": "Material",
    "product": "Producto"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "button",
        "no": "no",
        "title": "title",
        "yes": "yes"
      },
      "close": {
        "button": "button"
      },
      "eligibleProducts": {
        "checkbox": "checkbox",
        "error": {
          "title": "title"
        },
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "multiple",
            "none": "none",
            "single": "single"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "description",
          "title": "title"
        }
      },
      "header": {
        "description": {
          "default": "default",
          "noTraceabilityCampaign": "noTraceabilityCampaign",
          "runningJob": "runningJob"
        },
        "title": "title"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        }
      },
      "success": {
        "button": "button",
        "description": "description",
        "title": "title"
      }
    }
  },
  "maxError": "Debe ser menor o igual a {{max}}",
  "minError": "Debe ser mayor o igual a {{min}}",
  "operation": {
    "component": "Componente",
    "duplicateProductionSite": "Advertencia: se han detectado varias operaciones en este sitio.",
    "material": "Material",
    "notOwner": "La información ya ha sido proporcionada por: {{email}}",
    "product": "Producto",
    "purchaseOrderRef": "Referencia de la orden de compra",
    "reference": "Referencia de {{type}} para tu proveedor",
    "unknown": "otro contacto"
  },
  "operationNotCreated": "Ocurrió un error",
  "operationNotCreatedMessage": "La solicitud de información para esta solicitud no ha sido creada todavía, por favor contacta al soporte en support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "Transferir a otro contacto",
      "transferAll": "transferir todo."
    },
    "noRequests": {
      "closed": "No tienes solicitudes completadas.",
      "open": "No tienes solicitudes pendientes."
    },
    "status": {
      "INVALID": "Incompleto",
      "TOBESUBMITTED": "Listo para enviar"
    },
    "transferModal": {
      "success_one": "{{count}} valor de solicitud del sitio de producción transferido con éxito",
      "success_many": "{{count}} valores de solicitud del sitio de producción transferidos con éxito",
      "success_other": "{{count}} valores de solicitud del sitio de producción transferidos con éxito",
      "title": "Solicitar transferencia del sitio de producción",
      "transferButton": "Transferir"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Agregar un nuevo sitio de producción",
      "productionSite": "Sitio de producción"
    },
    "placeholders": {
      "productionSite": "Buscar un sitio de producción"
    }
  },
  "reopenRequest": {
    "error": "Error al volver a abrir la solicitud",
    "feedback_one": "{{count}} sub-solicitud cancelada",
    "feedback_many": "feedback",
    "feedback_other": "{{count}} sub-solicitudes canceladas",
    "title": "¿Estás seguro de que quieres reabrir esta solicitud? (esta acción cancelará todas las sub-solicitudes de esta solicitud)",
    "yes": "Sí, estoy seguro"
  },
  "request": {
    "complete": "Finalizar",
    "completeTooltip": "Haz clic aquí para completar y cerrar la solicitud. Cualquier sub-solicitud transferida será enviada al destinatario asignado.",
    "errors": {
      "generic": "Se produjo un error. Por favor, inténtalo de nuevo más tarde."
    },
    "incomplete": "Incompleto",
    "labels": {
      "composition": "Composición",
      "requestDate": "Fecha de solicitud"
    },
    "readyToSubmit": "Listo para enviar",
    "seeLess": "Ocultar solicitud",
    "seeMore": "Mostrar solicitud"
  },
  "requests": {
    "noRequests": {
      "closed": "Aún no has cerrado ninguna solicitud.",
      "open": "No tienes solicitudes pendientes esperando tu acción."
    },
    "tabs": {
      "canceled": "canceled",
      "certificates": {
        "scope": "Certificados de alcance",
        "transaction": "Certificados de transacción"
      },
      "closed": "Completadas",
      "prodsitefield": "Solicitud de sitio de producción",
      "traceability": "Solicitudes de trazabilidad"
    }
  },
  "requiredError": "Campo obligatorio",
  "selectAll": "Seleccionar todo",
  "sorts": {
    "client": "Cliente",
    "dueDate": "Fecha de entrega",
    "orderDate": "Fecha de pedido",
    "receptionDate": "Fecha de recepción de la solicitud",
    "reference": "Referencia"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Subido",
    "REJECTED": "",
    "UPLOADED": "Subido"
  },
  "submitModal": {
    "composition": "Composición",
    "confidenceStatement": "Por la presente, certifico solemnemente que la información proporcionada es correcta y completa",
    "confirmation_one": "{{count}} solicitud de trazabilidad enviada con éxito",
    "confirmation_many": "confirmation",
    "confirmation_other": "{{count}} solicitudes de trazabilidad enviadas con éxito",
    "error": "error",
    "noRequests": "No tienes solicitudes completas para enviar en esta página",
    "reference": "Referencia",
    "submitButton": "Confirmar ({{ itemCount }})",
    "title": "Selecciona todas las solicitudes que deseas enviar",
    "type": "Tipo"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "productionSite",
      "status": "Estado",
      "tags": "Etiquetas"
    }
  },
  "tooltips": {
    "contact": "Persona responsable de la información proporcionada.",
    "productionSite": "Un sitio registrado en tu repositorio donde se llevan a cabo las operaciones de fabricación o transformación. Cada sitio está generalmente asociado a un solo flujo de producción, excepto en caso de integración de varias operaciones.",
    "purchaseOrderRef": "Si no tienes una orden de compra para este {{type}}, puedes proporcionar un número de factura",
    "reference": "Referencia para identificar el artículo para tu proveedor"
  },
  "transferModal": {
    "success": "Solicitud de certificado transferida con éxito",
    "title": "Selecciona el contacto al que transferir el certificado"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Proveedor de accesorios",
    "accessoryRawMaterialProvider": "Proveedor de materia prima",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Granja (edredón)",
        "materialProduction": "Materia prima (edredón)",
        "preProcessor": "Preprocesador"
      },
      "fabric": {
        "appret": "Acabado (tejido)",
        "coating": "Recubrimiento (tejido)",
        "dyeing": "Tintura/Impresión (tejido)",
        "lamination": "Laminación",
        "materialProduction": "Materia prima (tejido)",
        "spinning": "Hilado (tejido)",
        "weavingKnitting": "Tejido/Punto"
      },
      "leather": {
        "appret": "Acabado (cuero)",
        "dyeing": "Tintura (cuero)",
        "farm": "Granja (cuero)",
        "materialProduction": "Matadero",
        "tanning": "Curtido de cuero"
      },
      "manufacturing": "Fabricación de confección",
      "yarn": {
        "dyeing": "Tintura (hilo)",
        "materialProduction": "Materia prima (hilo)",
        "spinning": "Hilado (hilo)"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entidadCertificada",
    "footwear": {
      "assembling": "Ensamblaje",
      "finishing": "Acabado",
      "stitching": "Costura"
    },
    "paper": {
      "assembling": "Montaje de papel",
      "bleaching": "Blanqueo",
      "chemicalTreatment": "Tratamiento químico",
      "laminating": "Laminado",
      "manufacturing": "Fabricación de papel",
      "pressing": "Prensado",
      "printing": "Impresión",
      "resineRemoving": "Eliminación de resina",
      "whiteWashing": "Lavado en blanco"
    },
    "product": {
      "productWashing": "Lavado de producto",
      "washing": "Lavado"
    },
    "wood": {
      "assembling": "Montaje de madera",
      "brushing": "Cepillado",
      "calibrationAndCollage": "Calibrado y collage",
      "harvesting": "Cosecha",
      "manufacturing": "Fabricación de madera",
      "materialDrying": "Secado",
      "materialPeeking": "Clasificación",
      "materialPeeling": "Pelado",
      "materialSawing": "Aserrado",
      "sanding": "Lijado"
    }
  }
}
